export const TRAVEL_HIGHLIGHTS = [
  {
    title: "60+ countries. Still curious.",
    text: "Travel gives me a reason to ask better questions, meet people outside my usual world, and get comfortable being a beginner again.",
  },
  {
    title: "A plan has to work on the ground",
    text: "A great museum is useless on its closed day. A beach stay has to fit the ferry. Remote work needs reliable Wi-Fi. These are the details I care about when planning a trip.",
  },
  {
    title: "Turning experience into tools",
    text: "I build travel skills that bring preferences, trip history, and practical constraints into AI-assisted planning. The goal: less time reconciling tabs, more time looking forward to the trip.",
  },
];
